import { render, staticRenderFns } from "./DxMonitoringPhenologies.vue?vue&type=template&id=2bc082aa&"
import script from "./DxMonitoringPhenologies.vue?vue&type=script&lang=js&"
export * from "./DxMonitoringPhenologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports